module.exports = __webpack_public_path__ + "static/media/music.03ddc387.jpg";